<script setup>
import { Avatar, DmButton, Icon, SideModal, getDateTime } from 'dmui_components'
import SectionChangelog from './SectionChangelog.vue'
import { computed, ref } from 'vue'

const props = defineProps({
	changelog: {
		type: Array,
		default: () => []
	},
	createdAt: {
		type: String,
		default: '',
		required: true
	}
})

const showModal = ref(false)

const UPDATE_TYPES_MAPPING = {
	create: 'created the report',
	update_source: 'updated the source',
	update_sections: 'updated sections',
	delete: 'deleted the report',
	retry: 'reprocessed the report',
	mark_done: 'updated the report',
	processed_targets: ' identified targets for the report'
}

const DEFAULT_ENTRY = { created_by: 'Anonymous', operation_type: 'create', created_at: props.createdAt }

const logs = computed(() => {
	if (props.changelog.length) {
		if (props.changelog[props.changelog.length - 1]?.operation_type === 'create') {
			return props.changelog
		} else {
			return [...props.changelog, DEFAULT_ENTRY]
		}
	}
	return [DEFAULT_ENTRY]
})
const getCreatedBy = (log) => (log.operation_type === 'mark_done' ? 'System' : log.created_by || 'Anonymous')
</script>
<template>
	<div class="changelog-item bordered-content">
		<Avatar :username="getCreatedBy(logs[0])" size="small" />
		<span class="tiny-text"> {{ getCreatedBy(logs[0]) }} {{ UPDATE_TYPES_MAPPING[logs[0]?.operation_type] }}</span>
		<span class="tiny-text date"> {{ getDateTime(logs[0]?.created_at) }} </span>
		<DmButton v-if="logs.length > 1" id="show-more-change-log" class="transparent secondary slim" @click="showModal = true"> See more </DmButton>
	</div>

	<SideModal v-if="showModal" :show-close-button="false" @update:show="showModal = $event">
		<div class="modal-content">
			<div class="modal-header page-header">
				<Icon name="uil-history-alt" size="medium" />
				<span>Report changelog</span>

				<DmButton id="close-btn" size="small" class="transparent secondary icon-only" @click="showModal = false">
					<Icon name="uil-times" size="medium" />
				</DmButton>
			</div>

			<div v-for="(change, index) in logs" :key="index" class="modal-item">
				<div class="changelog-item">
					<Avatar :username="getCreatedBy(change)" size="small" />
					<span class="tiny-text"> {{ getCreatedBy(change) }} {{ UPDATE_TYPES_MAPPING[change.operation_type] }}</span>
					<span class="tiny-text date"> {{ getDateTime(change.created_at) }} </span>
				</div>
				<div v-if="change.operation_type === 'update_sections' && change.additional_data">
					<SectionChangelog :updates="change.additional_data" />
				</div>
			</div>
		</div>
	</SideModal>
</template>
<style lang="less" scoped>
.changelog {
	display: flex;
	button {
		align-self: flex-end;
	}
}
.changelog-item {
	display: flex;
	flex: 1;
	align-items: center;
	gap: @micro;
	.date {
		margin-left: auto;
	}
	.tiny-text {
		color: @gray-80;
	}
}

.modal-item {
	margin: @medium 0;
}

.modal-content {
	padding: @midi @medium;
}
.modal-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: @midi;
	button {
		margin-left: auto;
	}
}
</style>
